/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Модель смены пароля пользователя */
export interface ChangedPasswordRecord {
  /**
   * Uid пользователя, пароль которого модифицируется
   * @format uuid
   */
  uid?: string;
  /**
   * Пока не обязательно
   * @deprecated
   */
  oldPassword?: string;
  /** Новый или временный пароль (регулируется флагом 'isTemporary') */
  newPassword?: string;
  /**
   * Должен ли пользователь обновить свой пароль при следующем входе?<br>(для Менеджеров - всегда true)
   * @default true
   */
  isTemporary?: boolean;
}

export interface ImportTemplateDto {
  /**
   * ID
   * @format int64
   */
  id?: number;
  name: string;
  data?: Record<string, object>;
  disabled?: boolean;
  deviceType?: ServiceTypesDictDto;
}

export interface PageImportTemplateDto {
  /** @format int32 */
  totalPages?: number;
  /** @format int64 */
  totalElements?: number;
  pageable?: PageableObject;
  /** @format int32 */
  numberOfElements?: number;
  /** @format int32 */
  size?: number;
  content?: ImportTemplateDto[];
  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface PageWorkContentDto {
  /** @format int32 */
  totalPages?: number;
  /** @format int64 */
  totalElements?: number;
  pageable?: PageableObject;
  /** @format int32 */
  numberOfElements?: number;
  /** @format int32 */
  size?: number;
  content?: WorkContentDto[];
  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface PageableObject {
  /** @format int32 */
  pageNumber?: number;
  unpaged?: boolean;
  paged?: boolean;
  /** @format int32 */
  pageSize?: number;
  /** @format int64 */
  offset?: number;
  sort?: SortObject[];
}

/** Новый профиль банковского расчёта */
export interface PaymentDto {
  /** Создатель записи */
  createdBy: string;
  /** Автор последнего изменения */
  lastModifiedBy?: string;
  /**
   * Дата создания записи
   * @format date-time
   */
  createdDate: string;
  /**
   * Дата последнего изменения
   * @format date-time
   */
  lastModifiedDate?: string;
  /**
   * ID
   * @format uuid
   */
  id?: string;
  /**
   * Компания-владелец данного способа оплаты
   * @format uuid
   */
  companyId: string;
  /**
   * Наименование банка
   * @minLength 3
   * @maxLength 255
   */
  bankName: string;
  /**
   * КПП
   * @minLength 3
   * @maxLength 127
   */
  kpp?: string;
  /**
   * БИК
   * @minLength 3
   * @maxLength 127
   */
  bik?: string;
  /**
   * Корреспондентский счёт
   * @minLength 3
   * @maxLength 127
   */
  cor?: string;
  /** Расчётный счёт */
  rs?: string;
}

/** Модель нового тарифа */
export interface RawTariffDto {
  /**
   * Идентификатор тарифа в БД
   * @format int64
   */
  id?: number;
  /** Название тарифа */
  title: string;
  /**
   * Доступное дисковое пространство
   * @format int64
   */
  diskSpace?: number;
  /**
   * Срок действия тарифа
   * @format int64
   */
  sortOrder: number;
  /** @uniqueItems true */
  durations?: TariffPeriodsRecord[];
  availableDiscSpaceExtend?: boolean;
  popularPricingPlan?: boolean;
}

export interface ServiceTypesDictDto {
  /** @format int64 */
  id?: number;
  /** ID */
  code?: string;
  higherCode?: string;
  /**
   * Компания-владелец услуги
   * @format uuid
   */
  companyId: string;
  name?: string;
  /** Описание */
  description?: string;
  /** @format int32 */
  sortOrder?: number;
  /**
   * Дата удаления
   * @format date-time
   */
  deletedDate?: string;
  /** Имя услуги на сайте */
  ui_name?: string;
}

export interface SortObject {
  direction?: string;
  nullHandling?: string;
  ascending?: boolean;
  property?: string;
  ignoreCase?: boolean;
}

export interface TariffPeriodsRecord {
  /** @format int64 */
  id?: number;
  period?: string;
  description?: string;
  /** @format int64 */
  price?: number;
}

export interface UserErrorMessage {
  /** @format date-time */
  timestamp?: string;
  code?: string;
  cause?: string;
  title?: string;
  message?: string;
  errorName?: string;
}

/** WorkContent заявки/услуги */
export interface WorkContentDto {
  /** Создатель записи */
  createdBy: string;
  /** Автор последнего изменения */
  lastModifiedBy?: string;
  /**
   * Дата создания записи
   * @format date-time
   */
  createdDate: string;
  /**
   * Дата последнего изменения
   * @format date-time
   */
  lastModifiedDate?: string;
  /**
   * id
   * @format int64
   */
  id?: number;
  /**
   * @minLength 0
   * @maxLength 256
   */
  name: string;
  modelName: string;
  /** Тип контента (WorkContent) */
  type:
    | "MODEL"
    | "DOCUMENTS"
    | "SOURCE_CONTENT"
    | "WORK_DATA"
    | "DEVICE_DICTIONARY"
    | "ANY";
  stage?: WorkStageDto;
  /**
   * Номер этапа заполнения (шага) в приложении
   * @format int64
   */
  stageId: number;
  /**
   * Является ли обязательным для заполнения
   * @default true
   */
  mandatory?: boolean;
  /** @format int32 */
  sortOrder?: number;
  defaultValue?: string;
  /** Тип контента web-формы (WorkContentInput) */
  inputType?:
    | "TEXT"
    | "NUMBER"
    | "DATE"
    | "BARCODE"
    | "IMAGE"
    | "STRING"
    | "FILE_PICKER"
    | "VIDEO"
    | "AUDIO"
    | "MULTIPLE";
  /**
   * Допускается ли правка значения
   * @default true
   */
  editable?: boolean;
  /**
   * В режиме доработки (после первичного завершения)
   * @default false
   */
  forRevisionOnly?: boolean;
  /**
   * Только для web-отображения (не на мобилке)
   * @default false
   */
  forWebOnly?: boolean;
  availableFileExtensions?: string;
  /** @format int32 */
  maxFilesAllowed?: number;
  deleted?: boolean;
  deviceType?: ServiceTypesDictDto;
  /** @format int64 */
  fieldId?: number;
}

export interface WorkStageDto {
  /** Создатель записи */
  createdBy: string;
  /** Автор последнего изменения */
  lastModifiedBy?: string;
  /**
   * Дата создания записи
   * @format date-time
   */
  createdDate: string;
  /**
   * Дата последнего изменения
   * @format date-time
   */
  lastModifiedDate?: string;
  /**
   * ID
   * @format int64
   */
  id?: number;
  name?: string;
  /** @uniqueItems true */
  availableForRoles: (
    | "NO_ONE"
    | "ROLE_VIEWER"
    | "ROLE_CUSTOMER"
    | "ROLE_WORKER"
    | "ROLE_MANAGER"
    | "ROLE_PROJECT_MANAGER"
    | "ROLE_DIRECTOR"
    | "ROLE_FUNCTIONAL_ADMIN"
    | "ROLE_OWNER"
    | "ROLE_ADMIN"
    | "ROLE_DEVELOPER"
    | "ROLE_FRONTEND"
  )[];
  /** @uniqueItems true */
  availableForEdit: (
    | "NO_ONE"
    | "ROLE_VIEWER"
    | "ROLE_CUSTOMER"
    | "ROLE_WORKER"
    | "ROLE_MANAGER"
    | "ROLE_PROJECT_MANAGER"
    | "ROLE_DIRECTOR"
    | "ROLE_FUNCTIONAL_ADMIN"
    | "ROLE_OWNER"
    | "ROLE_ADMIN"
    | "ROLE_DEVELOPER"
    | "ROLE_FRONTEND"
  )[];
  /** @uniqueItems true */
  availableForStatuses: string[];
  /** @format int32 */
  sortOrder?: number;
  forRevisionOnly?: boolean;
  needToPreSave?: boolean;
  deviceType?: ServiceTypesDictDto;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "http://11.0.0.33:8080",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Service Desk Api
 * @version 1.4.61
 * @baseUrl http://11.0.0.33:8080
 * @contact Konus-group <info@konus.group> (https://www.konus.group)
 *
 * Service desk System
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  template = {
    /**
     * @description Список активных (или отключенных) шаблонов парсинга документов (@Admin)
     *
     * @tags Templates
     * @name GetTemplate
     * @summary Получить список шаблонов
     * @request GET:/template
     * @secure
     */
    getTemplate: (
      query?: {
        /**
         * Выбрать отключённые?
         * @default false
         */
        isDisabled?: boolean;
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageImportTemplateDto, UserErrorMessage>({
        path: `/template`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Изменить существующий шаблон парсинга документов (@Admin)
     *
     * @tags Templates
     * @name PutTemplate
     * @summary Изменить шаблон
     * @request PUT:/template
     * @secure
     */
    putTemplate: (data: ImportTemplateDto, params: RequestParams = {}) =>
      this.request<ImportTemplateDto, UserErrorMessage>({
        path: `/template`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Создать новый шаблон парсинга документов (@Admin)
     *
     * @tags Templates
     * @name PostTemplate
     * @summary Создать шаблон вручную
     * @request POST:/template
     * @secure
     */
    postTemplate: (data: ImportTemplateDto, params: RequestParams = {}) =>
      this.request<ImportTemplateDto, UserErrorMessage>({
        path: `/template`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Найти шаблоны парсинга документов по id (@Admin)
     *
     * @tags Templates
     * @name GetTemplateFindByIDs
     * @summary Найти шаблоны
     * @request GET:/template/findByIDs
     * @secure
     */
    getTemplateFindByIDs: (
      query: {
        /** @uniqueItems true */
        ids: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ImportTemplateDto[], UserErrorMessage>({
        path: `/template/findByIDs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  payment = {
    /**
     * @description Обновить существующий профиль банковского расчёта (@Admin)
     *
     * @tags Payments
     * @name PutPayment
     * @summary Обновление профиля расчёта
     * @request PUT:/payment
     * @secure
     */
    putPayment: (data: PaymentDto, params: RequestParams = {}) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/payment`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Добавить профиль банковского расчёта указанной компании (@Admin)
     *
     * @tags Payments
     * @name PostPaymentCid
     * @summary Создание профиля расчёта
     * @request POST:/payment/{cid}
     * @secure
     */
    postPaymentCid: (
      cid: string,
      data: PaymentDto,
      params: RequestParams = {},
    ) =>
      this.request<PaymentDto, UserErrorMessage>({
        path: `/payment/${cid}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
  billing = {
    /**
     * @description Обновить существующий тариф (@Admin)
     *
     * @tags Tariffs
     * @name PutBillingTariffs
     * @summary Обновление тарифа
     * @request PUT:/billing/tariffs
     * @secure
     */
    putBillingTariffs: (data: RawTariffDto, params: RequestParams = {}) =>
      this.request<RawTariffDto, UserErrorMessage>({
        path: `/billing/tariffs`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Удалить существующие тарифы по id (@Admin)
     *
     * @tags Tariffs
     * @name DeleteBillingTariffs
     * @summary Удаление тарифов
     * @request DELETE:/billing/tariffs
     * @secure
     */
    deleteBillingTariffs: (data: number[], params: RequestParams = {}) =>
      this.request<number[], UserErrorMessage>({
        path: `/billing/tariffs`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Создать новый тариф (@Admin)
     *
     * @tags Tariffs
     * @name PostBillingTariffsCreate
     * @summary Создание тарифа
     * @request POST:/billing/tariffs/create
     * @secure
     */
    postBillingTariffsCreate: (
      data: RawTariffDto,
      params: RequestParams = {},
    ) =>
      this.request<RawTariffDto, UserErrorMessage>({
        path: `/billing/tariffs/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  accounts = {
    /**
     * @description Жесткий сброс пароля пользователя Админом (@Admin)
     *
     * @tags UserAccounts
     * @name PutAccountsResetPassword
     * @summary Сброс пароля пользователя
     * @request PUT:/accounts/resetPassword
     * @secure
     */
    putAccountsResetPassword: (
      data: ChangedPasswordRecord,
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/accounts/resetPassword`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  workContents = {
    /**
     * @description Список всех WorkContent
     *
     * @tags WorkContents
     * @name GetWorkContents
     * @summary Найти WorkContent
     * @request GET:/workContents
     * @secure
     */
    getWorkContents: (
      query?: {
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageWorkContentDto, UserErrorMessage>({
        path: `/workContents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  dicts = {
    /**
     * @description Уничтожить существующую причину отмены заявок (пакетно) (@Admin)
     *
     * @tags Rejection reasons
     * @name DeleteDictsSrRejections
     * @summary Удалить причину(ны) отмены
     * @request DELETE:/dicts/sr/rejections
     * @secure
     */
    deleteDictsSrRejections: (
      query: {
        /**
         * Коллекция названий причин отмены
         * @uniqueItems true
         */
        code: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<string[], UserErrorMessage>({
        path: `/dicts/sr/rejections`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  contracts = {
    /**
     * @description Удалить существующий контракт (@Admin)
     *
     * @tags Contracts
     * @name DeleteContractsCid
     * @summary Удалить контракт
     * @request DELETE:/contracts/{cid}
     * @secure
     */
    deleteContractsCid: (cid: number, params: RequestParams = {}) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/contracts/${cid}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  companies = {
    /**
     * @description Удаление компании по id (@Admin)
     *
     * @tags Companies
     * @name DeleteCompanies
     * @summary Удалить компании
     * @request DELETE:/companies
     * @secure
     */
    deleteCompanies: (data: string[], params: RequestParams = {}) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/companies`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  brigades = {
    /**
     * @description Уничтожить существующие бригады по id (@Admin)
     *
     * @tags Brigades
     * @name DeleteBrigades
     * @summary Удалить бригады
     * @request DELETE:/brigades
     * @secure
     */
    deleteBrigades: (data: string[], params: RequestParams = {}) =>
      this.request<string[], UserErrorMessage>({
        path: `/brigades`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
